import { Fill, Icon, Stroke, Style } from "ol/style";
import CircleStyle from "ol/style/Circle";
import { SvgIcons } from "../../local_modules/voyage-svg-icons/src/voyage-svg-icons";

export const mapIconSvgs = {
    selectedBorder: 'data:image/svg+xml;utf8,' + escape(`<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
    <circle cx="5.5" cy="5.5" r="4.75" fill="none" stroke="#90E3FF" stroke-width="1.5"/>
    </svg>`)
}

export const FleetIcons = {
    vesselShape: `<svg width="12" height="25" viewBox="0 0 12 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 9.46154V23L6 18.7692L11 23V9.46154L6 1L1 9.46154Z" fill="fillColor" stroke="strokeColor"/>
    </svg>`,

    missingHeading: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 8 8" fill="none">
    <rect x="1" y="1" width="6" height="6" fill="fillColor" stroke="strokeColor"/>
    </svg>`
}

const maerskVesselShapeStyle = new Style({
    image: new Icon({
        src: 'data:image/svg+xml,' + encodeURIComponent(SvgIcons.customVesselIcon2.strings[0]),
        scale: 1,
        anchor: [0.5, 0.5],
        rotateWithView: true,
    })
})

const maerskVesselWithAlarmShapeStyle = new Style({
    image: new Icon({
        src: 'data:image/svg+xml,' + encodeURIComponent(SvgIcons.customVesselWithAlarmIcon.strings[0]),
        scale: 1,
        anchor: [0.5, 0.5],
        rotateWithView: true,
    })
})

const nonMaerskShipShapeStyle = new Style({
    image: new Icon({
        src: 'data:image/svg+xml,' + encodeURIComponent(SvgIcons.customNonMaerskVesselIcon.strings[0]),
        scale: 1,
        anchor: [0.5, 0.5],
        rotateWithView: true,
        
    })
})
  
const nonMaerskDotStyle = new Style({
    image: new CircleStyle({
    radius: 4,
    fill: new Fill({
        color: "#FFD029",
    }),
    stroke: new Stroke({
        color: '#000000',
        width: 1,
        }),
    }),
});

const maerskVesselDotStyle = new Style({
    image: new CircleStyle({
    radius: 4,
    fill: new Fill({
        color: "#005487",
    }),
    stroke: new Stroke({
        color: '#000000',
        width: 1,
        }),
    }),
});

const vesselDot= new Style({
    image: new Icon({
        src: 'data:image/svg+xml,' + encodeURIComponent(SvgIcons.vesselDot.strings[0]),
        scale: 1,
        anchor: [0.5, 0.5],
        rotateWithView: true,

    })
})

const vesselDotSelected= new Style({
    image: new Icon({
        src: 'data:image/svg+xml,' + encodeURIComponent(SvgIcons.vesselDotSelected.strings[0]),
        scale: 1,
        anchor: [0.5, 0.5],
        rotateWithView: true,

    })
})

const maerskVesselDotWithAlarmStyle = new Style({
      image: new CircleStyle({
        radius: 4,
        fill: new Fill({
          color: '#B80012',
        }),
        stroke: new Stroke({
            color: '#000000',
            width: 1,
          }),
      }),
});

const maerskVesselWithoutHeadingStyle = new Style({
    image: new Icon({
        src: 'data:image/svg+xml,' + encodeURIComponent(SvgIcons.customVesselWithoutHeadingIcon.strings[0]),
        scale: 1,
        anchor: [0.5, 0.5]
    })
})

const nonMaerskVesselWithoutHeadingStyle = new Style({
    image: new Icon({
        src: 'data:image/svg+xml,' + encodeURIComponent(SvgIcons.customNonMaerskVesselWithoutHeadingIcon.strings[0]),
        scale: 1,
        anchor: [0.5, 0.5]
    })
})

const maerskVesselWithoutHeadingWithAlarmStyle = new Style({
    image: new Icon({
        src: 'data:image/svg+xml,' + encodeURIComponent(SvgIcons.customVesselWithoutHeadingIcon.strings[0]),
        scale: 1,
        anchor: [0.5, 0.5]
    })
})

export class MapStyles {
    static get maerskVesselShapeStyle() {
        return maerskVesselShapeStyle;
    }
    static get maerskVesselWithAlarmShapeStyle() {
        return maerskVesselWithAlarmShapeStyle;
    }
    static get maerskVesselDotStyle() {
        return maerskVesselDotStyle;
    }
    static get maerskVesselDotWithAlarmStyle() {
        return maerskVesselDotWithAlarmStyle;
    }
    static get maerskVesselWithoutHeadingStyle() {
        return maerskVesselWithoutHeadingStyle;
    }
    static get maerskVesselWithoutHeadingWithAlarmStyle() {
        return maerskVesselWithoutHeadingWithAlarmStyle;
    }
    static get nonMaerskShipShapeStyle() {
        return nonMaerskShipShapeStyle;
    }
    static get nonMaerskDotStyle() {
        return nonMaerskDotStyle;
    }
    static get nonMaerskVesselWithoutHeadingStyle() {
        return nonMaerskVesselWithoutHeadingStyle;
    }
}
